import axios from 'axios'
import React from 'react'



export default class API{

    static BASE_URL ='jza.tz:8588'
    //static BASE_URL ='localhost:8000'
    static API_URL = 'https://'+this.BASE_URL+'/api/'
    //static API_URL = 'http://'+this.BASE_URL+'/api/'

    static ax = axios
    static login(usn,psw){
        return this.ax.post(`auth/login`,{
            'Username':usn,
            'Password':psw
        },{
            onUploadProgress: function(progressEvent) {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                console.log("Uploading..."+percentCompleted)
            },
            onDownloadProgress: progressEvent => {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                console.log("Downloading..."+percentCompleted)
            },
        }).catch(e=>{
            console.log(e);
        }).catch(e=>{
            console.log(e)
        })
    }

    static logout(){
        return this.ax.get('auth/login').catch(e=>console.log(e))
    }

    static refresh(){
        return this.ax.get('auth/refresh').catch(e=>console.log(e))
    }

    static cancel(){
        const cancelTokenSource = axios.CancelToken.source();
        cancelTokenSource.cancel();
    }
}


axios.defaults.baseURL=API.API_URL
//
//axios.defaults.headers.common['X-Auth']=sessionStorage.getItem("x-auth")
axios.defaults.timeout.valueOf(86400000)
// Add a request interceptor

if (sessionStorage.getItem('token')!==null){
    axios.defaults.headers.common['Authorization']=sessionStorage.getItem('token')
    /*sessionStorage.setItem('access_expires_in',r.data.access_expires_in)
                    sessionStorage.setItem('',r.data.access_token)
                    sessionStorage.setItem('refresh_expires_in',r.data.refresh_expires_in)
                    sessionStorage.setItem('refresh_token',r.data.refresh_token)
                    sessionStorage.setItem('',r.data.token_type)
                    sessionStorage.setItem('login','1')*/
}

axios.interceptors.request.use(config=>{
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    setTimeout(()=>source.cancel('Timed out after 30s'), 86400000);
    return config;
});

axios.interceptors.response.use(function (response) {
    //console.log('AX Responding........'+JSON.stringify(response))
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    //console.log('AX Responding........'+error)
     if (error.response.status === 401) {

         /*sessionStorage.clear()
         window.location.reload()
         console.log('Invalid User')*/
     }
    return Promise.reject(error);
});

/*
axios.interceptors.response.use(response => {
   return response;
}, error => {
  if (error.response.status === 401) {
   //place your reentry code
  }
  return error;
});
*/
